var _rect, _rect2, _rect3, _path, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint0_linear_193_63)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.3154,
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint1_linear_193_63)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20.6318,
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint2_linear_193_63)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4097 11.4984C11.7548 11.1222 11.8927 9.04255 12.1686 8.04975C12.8792 5.82884 14.5992 4.49657 16.6162 4.13081C18.6331 3.76504 21.1155 4.18306 22.3567 5.17585C23.5979 6.16865 24.7356 8.04975 24.2702 10.4011C23.8047 12.7525 21.6844 13.7975 21.3224 13.9543C20.9603 14.111 20.4432 14.6336 20.3397 15.4696C20.2363 16.3056 19.7709 16.8282 19.202 17.0372C18.6331 17.2462 15.9439 17.3507 15.6853 15.3651C15.4267 13.3795 16.8747 12.2822 17.2885 12.0209C17.7022 11.7597 19.4606 10.5056 19.6157 9.66957C19.7709 8.83353 19.4088 8.04975 18.6848 7.84074C17.9608 7.63173 16.9265 8.04975 16.9782 9.04254C17.0299 10.0353 16.7028 10.6268 16.6162 10.7669C16.3576 11.1849 15.4784 11.9687 13.4097 11.4984Z",
    fill: "white",
    fillOpacity: 0.82
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6201,
    y: 18.3174,
    width: 5.17164,
    height: 4.70273,
    rx: 2.35136,
    fill: "white",
    fillOpacity: 0.82
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_63",
    x1: -3.5439e-7,
    y1: 4.36288,
    x2: 17.5231,
    y2: 17.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_63",
    x1: -3.5439e-7,
    y1: 14.6783,
    x2: 17.5231,
    y2: 28.1441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_63",
    x1: -3.5439e-7,
    y1: 24.9947,
    x2: 17.5231,
    y2: 38.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHint);
export default __webpack_public_path__ + "static/media/link-hint.784eb5c731517786d6082be5ecfeb642.svg";
export { ForwardRef as ReactComponent };